// Libraries
import React from 'react';

// Enums
import { OrderedQuestionDataType } from 'engagementReport/enums/propTypes';

// Hooks
import useOrderedPieChartData from 'engagementReport/hooks/useOrderedPieChartData';

// Components
import OrderedPieChart from 'engagementReport/components/ordered/OrderedPieChart';

const OrderedPieCharts = ({ data }) => {
  const chartData = useOrderedPieChartData(data);

  return chartData.map(({ label, values }, index) => (
    // eslint-disable-next-line react/no-array-index-key
    <OrderedPieChart label={label} values={values} key={index} />
  ));
};

OrderedPieCharts.propTypes = {
  data: OrderedQuestionDataType.isRequired,
};

export default OrderedPieCharts;
